<template>
    <m-main-layout>
        <div class="page-content-main">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="auto" class="margin-top"
                     style="width:800px;">
                <el-form-item label="Logo" prop="logo">
                    <div class="el-upload el-upload--picture-card margin-right rel margin-bottom hide" v-if="formData.logo">
                        <img :src="formData.logo.indexOf('http') >= 0 ? formData.logo+'!thumb' : $config.assetsUrl+formData.logo" style="width:100%;vertical-align: middle;"/>
                        <span class="miihe-upload-item">
                            <span @click="showBigImg(formData.logo)"><i class="el-icon-zoom-in"></i></span>
                            <span @click="delBigImg()"><i class="el-icon-delete"></i></span>
                        </span>
                    </div>
                    <image-dialog :limit="1" :min="0" :max="1" :data="formData.logo ? [formData.logo] : []" @on-choose="onChooseImage" showType="block" imgKey="logo">添加图片</image-dialog>
                    <el-dialog :visible.sync="bigImgIsShow">
                        <img width="100%" :src="bigImgUrl" alt="">
                    </el-dialog>
                    建议尺寸 750*750
                </el-form-item>
                <el-form-item label="店铺名称" prop="shop_name">
                    <el-input v-model="formData.shop_name" maxlength="20" show-word-limit
                              style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="客服电话" prop="service_tel">
                    <el-input v-model="formData.service_tel" maxlength="20" show-word-limit
                              style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="企业名称" prop="company_name">
                    <el-input v-model="formData.company_name" maxlength="30" show-word-limit
                              style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="企业地址" prop="company_address">
                    <el-input v-model="formData.company_address" maxlength="30" show-word-limit
                              style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "add",
    data() {
        return {
            formData: {
                shop_name: '',
                service_tel: '',
                company_name: '',
                company_address: '',
                logo:''
            },
            bigImgUrl: '',
            bigImgIsShow: false,
            rules: {
                shop_name: [{required: true}],
                // service_tel: [{required: true}],
                company_name: [{required: true}],
                // company_address: [{required: true}],
                logo: [{required: true}],
            },
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        showBigImg(item) {
            this.bigImgUrl = item.indexOf('http') >= 0 ? item : this.$config.assetsUrl + item;
            this.bigImgIsShow = true;
        },
        delBigImg() {
            this.formData.logo = '';
        },
        onChooseImage(e) {
            this.formData.logo = e[0];
        },
        submitForm(formName) {
            let _this = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // console.log(_this.formData);
                    _this.$http.httpPost({
                        url: 'System/edit',
                        datas: _this.formData,
                        success: (res) => {
                            if (res === 'ok') {
                                _this.$message.success('修改成功');
                            } else {
                                _this.$message.error('修改失败');
                            }
                            // _this.$message.info(res.msg);
                            // _this.$router.replace({path: '/cate/list'})
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getDetail() {
            let _this = this;

            let _skeys = [];

            for (let k in this.formData) {
                _skeys.push(k);
            }

            _this.$http.httpPost({
                url: 'System/getSystem',
                datas: {skey: _skeys},
                success: (res) => {
                    _this.formData = res;
                    // console.log(res);
                    // _this.$message.info(res.msg);
                    // _this.$router.replace({path: '/cate/list'})
                }
            });
        }
    }
}
</script>
